import { BeforeLoadContextParameter } from '@tanstack/react-router'

/**
 * Agency authentication
 * @param props
 */
export const agencyAuth = async (props: BeforeLoadContextParameter<any, any, any>) => {
  const { params, context } = props
  const { id } = params
  const { authUser } = context

  const allowedAgencies = authUser?.allowed_agencies.split(',').map((id: string) => parseInt(id))

  if (!allowedAgencies.includes(Number(id))) {
    throw new Error('Unauthorized')
  }

}
